 <template>
  <v-dialog v-model="studentProfile.dialog" width="616">
    <v-card class="blue-title">
      <v-card-title class="headline text-xs-center font-weight-bold blue-title">
        <v-spacer></v-spacer>
        <p style="text-align: left;width:100%;padding-top:10px;margin:0 17px">Student Profile</p>
        <v-spacer></v-spacer>
        <div
          class="header-close"
          title="close"
          @click="studentProfile.dialog = false"
        >
          <v-icon>close</v-icon>
        </div>
      </v-card-title>
      <v-card-text>
        <v-layout>
          <v-flex xs6>
              <p>
                Name: <strong>{{stupeson.Name}}</strong>
                <img v-if="stupeson.Gender==0" src="../../assets/img/common/women.png" class="sex">
                <img v-if="stupeson.Gender==1" src="../../assets/img/common/men.png" class="sex">
              </p>
              <p>Total lesson with me: <strong>{{stuInfo.TotalLessonWithMe}}</strong></p>
              <p>Hobbies: {{stupeson.Hobbies || "No data yet"}}</p>
              <p>Character: {{stupeson.Character || "No data yet"}}</p>
          </v-flex>
          <v-flex xs6>
              <p>Age: <strong>{{stupeson.Age}}</strong></p>
              <p>Total lesson with Acadsoc: <strong>{{stupeson.TotalLessonWithAcadsoc}}</strong></p>
          </v-flex>
        </v-layout>
        <p class="title_s">Learning Goal:</p>
        <p>Improve your oral English, and be able to communicate with foreigners fluently</p>
        <p class="title_s">Teaching Preferences:</p>
        <p>Requirements for Speaking Speed: {{teach!=null ? teach.TalkSpeed : "No data yet"}}</p>
        <p>Error Correction Mode：{{teach!=null ? teach.CorrectionWay : "No data yet"}}</p>
        <p>Usage of Textbook：{{teach!=null ? teach.TextbookUsage : "No data yet"}}</p>
        <p>Class Atmosphere：{{teach!=null ? teach.ClassAtmosphere : "No data yet"}}</p>
        <p class="title_s">CEFR Level:</p>
        <div class="cefr">
            <div class="level_top">
                <div class="li1 white_b"></div>
                <div class="li2">
                    <p style="height:20px;margin-top:180px">L0</p>
                </div>
                <div class="li3">
                    <p style="height:30px;margin-top:170px">L1</p>
                    <p style="height:40px;margin-top:160px">L2</p>
                    <p style="height:50px;margin-top:150px">L3</p>
                </div>
                <div class="li3">
                    <p style="height:60px;margin-top:140px">L4</p>
                    <p style="height:70px;margin-top:130px">L5</p>
                    <p style="height:80px;margin-top:120px">L6</p>
                </div>
                <div class="li3">
                    <p style="height:90px;margin-top:110px">L7</p>
                    <p style="height:100px;margin-top:100px">L8</p>
                    <p style="height:110px;margin-top:90px">L9</p>
                </div>
                <div class="li3">
                    <p style="height:120px;margin-top:80px">L10</p>
                    <p style="height:130px;margin-top:70px">L11</p>
                    <p style="height:140px;margin-top:60px">L12</p>
                </div>
                <div class="li3">
                    <p style="height:150px;margin-top:50px">L13</p>
                    <p style="height:160px;margin-top:40px">L14</p>
                    <p style="height:170px;margin-top:30px">L15</p>
                </div>
                <div class="li4 white_b">
                    <p style="height:180px;margin-top:20px">L16</p>
                </div>
                <span class="lv">Acadsoc Level</span>
                <p class="level_s now_l" :style="{'bottom':Nbottom+'px','left': Nleft+'%'}">
                    <span>Student's Level</span><br>
                    <img src="../../assets/img/common/Subtract.png" alt="">
                </p>
                <p class="level_s now_f" :style="{'bottom':Gbottom+'px','left': Gleft+'%'}">
                    <span>Target Level</span><br>
                    <img src="../../assets/img/common/flag.png" alt="">
                </p>
            </div>
            <div class="level_down">
                <p class="li1">CEFR</p>
                <p class="li2">Pre-A1</p>
                <p class="li3">A1</p>
                <p class="li3">A2</p>
                <p class="li3">B1</p>
                <p class="li3">B2</p>
                <p class="li3">C1</p>
                <p class="li4">C2</p>
            </div>
        </div>
        <p class="title_s" v-if="stuInfo.lessonMaterial != null">Key Points of The Previous Class:</p>
        <div class="imgtitle">
          <a
            v-for="(item, int) in classTab"
            :key="int"
            :class="int === index ? 'vvv' : ''"
            @click="turnPage(int,item.key)"
            >{{ item.key }}({{item.much}})
          </a>
        </div>
        <div class="key_p">
          <p
            v-for="(item, int) in classContent[index]"
            :key="int"
            :class="!item.ischecked ? 'ccc' : ''"
            >{{int+1}}.{{ item.text }}
          </p>
        </div>
        <p class="hint" v-if="stuInfo.lessonMaterial != null">The key points that the student did not master in the previous class are marked in red.</p>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import {AddTutorEventLog} from '@/api/classtable.js'
export default {
  name: "studentProfile",
  props: {
    studentProfile: {
      dialog: false,
      info: "",
      clId: "",
      uid: "",
    },
  },
  data: () => ({
      classTab: [],
      classContent: [],
      index: 0,
      stuInfo: "",
      stupeson: "",
      teach: "",
      stuTimer: null,
      time: 0,
      Nbottom: 20,
      Nleft: 10,
      Gbottom: 20,
      Gleft: 12,
  }),
  methods: {
    turnPage(int,name) {
      this.index = int;
      var param = {
        title: "ClassDetail",
        popup_title: "学生档案",
        class_id: this.studentProfile.clId,
        tuid: this.$store.state.user.tuid,
        last_class_id: this.stuInfo.LastCLID,
        last_class_tuid: this.stuInfo.LastTUID,
        tab_name: name,
        tab_position: this.index+1,
        tab_contents:this.classContent[this.index],
      }
      this.time = 0;
      AddTutorEventLog(3,JSON.stringify(param)).then(r => {})
    }
  },
  watch: {
    "studentProfile.dialog": function (value) {
      if (value) {
        this.stuInfo = this.studentProfile.info
        this.classTab = [];
        this.classContent = [];
        for(var key in this.stuInfo.lessonMaterial){
          this.classTab.push({key:key,much:this.stuInfo.lessonMaterial[key].length})
          this.classContent.push(this.stuInfo.lessonMaterial[key])
        }
        this.Nbottom += this.stuInfo.CEFRLevel*10;
        this.Nleft += this.stuInfo.CEFRLevel*5;
        this.Gbottom += this.stuInfo.GoalLevel*10;
        this.Gleft += this.stuInfo.GoalLevel*4.9;
        this.stupeson = this.studentProfile.info.manageStuInfo
        this.teach = this.studentProfile.info.manageStuInfo.TeachingPreferences
        this.stuTimer = setInterval(()=>{
          this.time++;
        },1000)
        var param = {
          title: "classDetail",
          popup_title: "学生档案",
          class_id: this.studentProfile.clId,
          tuid: this.$store.state.user.tuid
        }
        AddTutorEventLog(5,JSON.stringify(param)).then(r =>{})
      }else {
        clearInterval(this.stuTimer);
        this.stuTimer = null;
        var param = {
            title: "classDetail",
            popup_title: "学生档案",
            class_id: this.studentProfile.clId,
            tuid: this.$store.state.user.tuid,
            open_type: 0,
            event_duration: this.time,
            name: this.stupeson.Name,
            sex: this.stupeson.Gender,
            age: this.stupeson.Age,
            lesson_with_me: this.stuInfo.TotalLessonWithMe,
            lesson_with_acadsoc: this.stupeson.TotalLessonWithAcadsoc,
            hobbies: this.stupeson.Hobbies,
            character: this.stupeson.Character,
            learning_goal: this.stupeson.LearningGoal.replace("&","%26"),
            CEFR_level: this.stuInfo.CEFRLevel,
            speaking_speed: this.teach.TalkSpeed,
            textbook_usage: this.teach.TextbookUsage,
            correction_mode: this.teach.CorrectionWay,
            class_atmosphere: this.teach.ClassAtmosphere,
            tab_contents: this.classContent,
        }
        this.time = 0;
        AddTutorEventLog(2,JSON.stringify(param)).then(r => {})
      }
    },
  },
};
</script>
<style lang="scss" scoped>
p {
  margin-bottom: 10px;
}
.title_s {
    color: #3E67FB;
    font-weight: 600;
    margin-top: 30px;
}
.imgtitle {
  width: 100%;
  margin-bottom: 20px;
  a {
    display: inline-block;
    height: 30px;
    line-height: 30px;
    background: white;
    color: #3e67fb;
    text-align: center;
    font-size: 14px;
    box-shadow: 0px 4px 4px rgba(153, 171, 234, 0.2);
    border-radius: 4px;
    margin-right: 10px;
    border: 1px solid #3E67FB;
    padding: 0 8px;
  }
  .vvv {
    background: #3e67fb;
    color: white;
    font-weight: 600;
  }
}
.key_p {
    width: 100%;
    p {
        width: 48%;
        height: 30px;
        background-color: #F0F6FF;
        color: #353966;
        display: inline-block;
        line-height: 30px;
        padding-left: 10px;
        border-radius: 4px;
    }
    .ccc {
        background-color: #FFF0F0;
        color: #EE344C;
    }
    p:nth-child(even) {
        margin-left: 2%;
    }
    p:nth-child(odd) {
        margin-right: 2%;
    }
}
.hint {
    color:#EE344C;
    font-size: 12px;
    margin-top: 10px;
}
.cefr {
    color: white;
    p {
        display: inline-block;
        font-size: 12px;
        text-align: center;
    }
    .level_top {
        width: 100%;
        height: 200px;
        position: relative;
        div {
            position: absolute;
            bottom: 0;
            margin: 0;
            height: 200px;
        }
        div:nth-of-type(2) {left: 13%;}
        div:nth-of-type(3) {left: 20%;}
        div:nth-of-type(4) {left: 34%;}
        div:nth-of-type(5) {left: 48%;}
        div:nth-of-type(6) {left: 62%;}
        div:nth-of-type(7) {left: 76%;}
        div:nth-of-type(8) {left: 90%;}
        .li3,.li2,.li4 {
            display: flex;
            p {
                flex: 1;
                text-align: center;
                border-right: 1px solid white;
                border-bottom: 1px solid white;
                margin: 0;
            }
        }
        .white_b {
            border-right: 1px solid white;
        }
        .lv {
            font-size: 10px;
            position: absolute;
            bottom: 1%;
            left: -1%;
            transform:scale(0.8);
            color: #323233;
        }
        .level_s {
            color: #323233;
            position: absolute;
            border: none;
            margin: 0;
        }
        .now_l {
            bottom: 40px;
            left: 20%;
        }
        .now_f {
            bottom: 110px;
            left: 55%;
        }
    }
    .level_down {
        width: 100%;
        height: 24px;
        p {
            height: 24px;
            line-height: 24px;
            border-right: 1px solid white;
        }
    }
    .level_down>p:nth-of-type(1),.level_top>div:nth-of-type(1)>p {background-color: #1A2D78;}
    .level_down>p:nth-of-type(2),.level_top>div:nth-of-type(2)>p {background-color: #6097C9;}
    .level_down>p:nth-of-type(3),.level_top>div:nth-of-type(3)>p {background-color: #4C83B5}
    .level_down>p:nth-of-type(4),.level_top>div:nth-of-type(4)>p {background-color: #317FC8}
    .level_down>p:nth-of-type(5),.level_top>div:nth-of-type(5)>p {background-color: #297AC6}
    .level_down>p:nth-of-type(6),.level_top>div:nth-of-type(6)>p {background-color: #1574CE}
    .level_down>p:nth-of-type(7),.level_top>div:nth-of-type(7)>p {background-color: #1167CD}
    .level_down>p:nth-of-type(8),.level_top>div:nth-of-type(8)>p {background-color: #0040AF}
    .li1 {
        width: 13%;
    }
    .li2 {
        width: 7%;
    }
    .li3 {
        width: 14%;
    }
    .li4 {
        width: 10%;
    }
}
.v-card__text {
  padding: 10px 33px;
}
.sex {
  position: relative;
  top: 3px;
  left: 5px;
}
</style>
